import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import SeoGuide from "../pages/seo-guide/page";
import SeoSafety from "../pages/seo-safety/page";
import SeoVsCompetitors from "../pages/seo-vs-competitors/page";
import SeoBestShoes from "../pages/seo-best-shoes/page";
import SeoVerify from "../pages/seo-verify/page";
import SeoTopRanked from "../pages/seo-top-ranked/page";
import SeoBeginners from "../pages/seo-beginners/page";
import SeoHiddenFinds from "../pages/seo-hidden-finds/page";
import SeoStrategy from "../pages/seo-strategy/page";
import SeoFuture from "../pages/seo-future/page";

const routes: RouteObject[] = [
  { path: "/", element: <Home /> },
  { path: "/mulebuy-spreadsheet-guide", element: <SeoGuide /> },
  { path: "/mulebuy-spreadsheet-safety", element: <SeoSafety /> },
  { path: "/mulebuy-spreadsheet-vs-competitors", element: <SeoVsCompetitors /> },
  { path: "/best-shoes-mulebuy-spreadsheet", element: <SeoBestShoes /> },
  { path: "/verify-mulebuy-spreadsheet", element: <SeoVerify /> },
  { path: "/top-mulebuy-spreadsheets-ranked", element: <SeoTopRanked /> },
  { path: "/mulebuy-spreadsheet-beginners", element: <SeoBeginners /> },
  { path: "/hidden-finds-mulebuy-spreadsheet", element: <SeoHiddenFinds /> },
  { path: "/mulebuy-spreadsheet-strategy", element: <SeoStrategy /> },
  { path: "/future-product-sourcing-spreadsheets", element: <SeoFuture /> },
  { path: "*", element: <NotFound /> },
];

export default routes;